<template>
  <div class="enterprise_list">
    <a href="/exhibition_list" target="_blank">环保展会信息</a>
    <div class="swiper-list">
      <div class="button-prev" @click="swiperChange('prev')">
        <svg
          t="1603440419638"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2695"
          width="32"
          height="32"
        >
          <path
            d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
            p-id="2696"
            fill="#8a8a8a"
          ></path>
        </svg>
      </div>
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide box"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="imgBox" :style="{backgroundImage:`url(${item.cover.split(',')[0]})`}"></div>
          </div>
        </div>
      </div>
      <div class="button-next" @click="swiperChange('next')">
        <svg
          t="1603440337801"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2017"
          width="32"
          height="32"
        >
          <path
            d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
            p-id="2018"
            fill="#8a8a8a"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  props:{
     list:{
       type:Array
     }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 10, // 每张的间距
      },
      currPage:1
    };
  },
  created(){
    
  }, 
  methods: {
    toDetail(item){
      // routerGoNewpage('/exhibition_detail',{id:item.id})
     routerGoNewpage('/exhibition_list',{})
    },
    goToUrl(url) {
      this.$router.push(url);
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
            this.currPage ++;
            this.$emit('onParants',this.currPage)
          }
          break;
      }
    }
  },
};
</script>

<style scoped lang="less">
.enterprise_list {
  /deep/.swiper-container{
    width: 100%;
  }
  a{
    margin-top: 30px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    position: relative;
    margin-left: 15px;
    margin-bottom: 15px;

    &::before {
      display: inline-block;
      content: "";
      width: 5px;
      height: 23px;
      background: #ff7302;
      position: absolute;
      left: -15px;
      bottom: 4px;
    }
  }
  .swiper-list {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .button-prev,
    .button-next {
      cursor: pointer;
      // position: absolute;
      // top: 25%;
      z-index: 999;
    }
    .button-next {
      // right: 0;
    }
    .swiper-container {
      .box {
        text-align: center;
        .imgBox {
          cursor: pointer;
          width: 100%;
          height: 110px;
          background-size: cover;
          background-position: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/exhibitionInformation.vue